module.exports = __webpack_public_path__ + "img/op_img-header-mobile.3c1cbe2.png";